import { PDP_FIND_ON_DISPLAY } from "@/constants/index"

export const addAnalyticsClickStoreNear = data => {
  const { productDisplayTitle = "", sectionHeadingProductNotAvailable = "" } =
    data
  const eventInfo = {
    eventAction: `pdp:cross-sell:${sectionHeadingProductNotAvailable}`,
    eventName: `pdp:cross-sell:${sectionHeadingProductNotAvailable}`,
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: sectionHeadingProductNotAvailable,
    internalLinkPosition: "pdp",
    internalLinkType: `pdp:${productDisplayTitle}`,
    internalLinkZoneName: `pdp:cross-sell:${productDisplayTitle}`,
    internalLinkURL: window.location.href,
    clickInternalLinks: "true",
  }
  pushAnalyticsObjToDataLayer(eventInfo)
}

export const addAnalyticsClickChangeZipSubmit = data => {
  const {
    zipCode = "n/a",
    eventZipStatus = "n/a",
    eventZipCodeAction = "n/a",
    submitLabel = "n/a",
    eventMessageLabel = "n/a",
  } = data
  const eventInfo = {
    eventAction: `${PDP_FIND_ON_DISPLAY}:${eventZipCodeAction}`,
    eventName: `${PDP_FIND_ON_DISPLAY}:${eventZipCodeAction}`,
    eventType: "navigation",
    eventMsg: eventMessageLabel,
    eventStatus: eventZipStatus || "n/a",
    internalLinkName: submitLabel?.toLowerCase() || "n/a",
    internalLinkPosition: `${PDP_FIND_ON_DISPLAY}:${eventZipCodeAction}`,
    internalLinkType: `pdp${zipCode ? `:${zipCode}` : ""}`,
    internalLinkZoneName: PDP_FIND_ON_DISPLAY,
    internalLinkURL: window.location.href,
    clickInternalLinks: "true",
  }
  pushAnalyticsObjToDataLayer(eventInfo)
}

export const addAnalyticsBrowseStoreNotFound = data => {
  const {
    nonAvailableLabel = "n/a",
    browseAllLabel = "n/a",
    zipCode = "n/a",
    submitLabel = "n/a",
  } = data
  const eventInfo = {
    eventAction: `${PDP_FIND_ON_DISPLAY}:${browseAllLabel} not found`,
    eventName: `${PDP_FIND_ON_DISPLAY}:${browseAllLabel} not found`,
    eventType: "navigation",
    eventMsg: nonAvailableLabel,
    eventStatus: "failure",
    internalLinkName: submitLabel?.toLowerCase() || "n/a",
    internalLinkPosition: `${PDP_FIND_ON_DISPLAY}:${browseAllLabel} not found`,
    internalLinkType: `pdp:${zipCode}`,
    internalLinkZoneName: PDP_FIND_ON_DISPLAY,
    internalLinkURL: "n/a",
    clickInternalLinks: "true",
  }
  pushAnalyticsObjToDataLayer(eventInfo)
}

export const addAnalyticsProductNameDisplayClick = data => {
  const {
    locationName = "n/a",
    locality = "n/a",
    adminDistrict = "",
    url = "",
  } = data
  const eventInfo = {
    eventAction: `pdp:find on display:browse all stores:store name`,
    eventName: `pdp:find on display:browse all stores:store name`,
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: locationName,
    internalLinkPosition: `pdp:find on display:${locationName}`,
    internalLinkType: `pdp:find on display${locality ? `:${locality}` : ""}${
      adminDistrict ? `:${adminDistrict}` : ""
    }`,
    internalLinkZoneName: "pdp:find on display:browse all stores",
    internalLinkURL: window.location.origin + url,
    clickInternalLinks: "true",
  }
  pushAnalyticsObjToDataLayer(eventInfo)
}

export const addAnalyticsStoreNumberClick = data => {
  const {
    locationName = "n/a",
    locality = "n/a",
    adminDistrict = "",
    url = "",
    contactNumber = "",
  } = data
  const eventInfo = {
    eventAction: `pdp:find on display:browse all stores:store name`,
    eventName: `pdp:find on display:browse all stores:store name`,
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: `call us:${contactNumber}`,
    internalLinkPosition: `pdp:find on display:${locationName}`,
    internalLinkType: `pdp:find on display${locality ? `:${locality}` : ""}${
      adminDistrict ? `:${adminDistrict}` : ""
    }`,
    internalLinkZoneName: "pdp:find on display:browse all stores",
    internalLinkURL: window.location.origin + url,
    clickInternalLinks: "true",
  }
  pushAnalyticsObjToDataLayer(eventInfo)
}

export const addAnalyticsBrowseAllStoreClick = data => {
  const { browseAllLabel = "n/a", browseAllStoreUrl = "n/a" } = data
  const eventInfo = {
    eventAction: `pdp:find on display:${browseAllLabel}`,
    eventName: `pdp:find on display:${browseAllLabel}`,
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: browseAllLabel,
    internalLinkPosition: `pdp:find on display:${browseAllLabel}`,
    internalLinkType: "pdp:find on display",
    internalLinkZoneName: `pdp:find on display:${browseAllLabel}`,
    internalLinkURL: window.location.origin + browseAllStoreUrl,
    clickInternalLinks: "true",
  }
  pushAnalyticsObjToDataLayer(eventInfo)
}

export const addAnalyticsCloseSliderProductOnDisplay = data => {
  const eventInfo = {
    eventAction: "pdp:find on display:close",
    eventName: "pdp:find on display:close",
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: "close",
    internalLinkPosition: "pdp:find on display:close",
    internalLinkType: "pdp:find on display",
    internalLinkZoneName: "pdp:find on display",
    internalLinkURL: "n/a",
    clickInternalLinks: "true",
  }
  pushAnalyticsObjToDataLayer(eventInfo)
}

const pushAnalyticsObjToDataLayer = (eventInfo = {}) => {
  const page = window.pageObj || {}
  const event = "cmp:click"
  const { productInfo } = page
  window.adobeDataLayer.push({
    event,
    eventInfo,
    page,
    productInfo,
  })
}
